import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ScreenLoader from "../../../components/ScreenLoader";
import { showForAllExceptManager, isRoleExits } from "../../../utils";
import AddEditBetGameModal from "../../../components/Models/AddEditBetGameModal";
import actions from "../../../redux/actions";
import { useSelector } from "react-redux";
import { notifyError, notifySuccess } from "../../../components/ToastContext";

const SMGamesTable = () => {
  const [editFormData, setEditFormData] = useState({});
  const [loader, setLoader] = useState(true);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const eventMarketList = useSelector((state) => state.SM.SMEventMarketList);
  const eventMarket = eventMarketList.Result;

  // Handlers for modal visibility
  const handleEditShow = () => setShowEditModal(true);
  const handleEditClose = () => setShowEditModal(false);
  const handleCreateShow = () => setShowCreateModal(true);
  const handleCreateClose = () => setShowCreateModal(false);

  // Simulate updating the client list
  const updateListHandler = () => {
    console.log("Updating client list...");
  };

  // Simulate updating the client list
  const editEventMarket = (eventData) => {
    handleEditShow();
    setEditFormData(eventData);
  };
  const handleMarketActive = async (eventID) => {
    try {
      let response = await actions.SetSMEventStatus(eventID);
      if (response?.data?.Status) {
        notifySuccess(response.data.Result);
        await actions.GetSMEventMarketList();
      } else {
        notifyError(response?.data?.Result || "Failed to RollBack result.");
      }
    } catch (error) {
      notifyError("Something went wrong.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await actions.GetSMEventMarketList();
      setLoader(false);
    };

    fetchData();
  }, []); // Dependency array to ensure effect runs only once

  return (
    <>
      {/* Add Modal */}
      {showCreateModal && (
        <AddEditBetGameModal
          mode="add"
          showModal={showCreateModal}
          handleModalClose={handleCreateClose}
          handleClientList={updateListHandler}
        />
      )}

      {/* Edit Modal */}
      {showEditModal && (
        <AddEditBetGameModal
          mode="edit"
          showModal={showEditModal}
          handleModalClose={handleEditClose}
          handleClientList={updateListHandler}
          gameData={editFormData}
        />
      )}

      <div className="content-header-btn">
        All Games
        <div className="text-right">
          {(showForAllExceptManager() || isRoleExits("user_create")) && (
            <button
              className="custom-green-btn"
              style={{ fontSize: "13px" }}
              onClick={handleCreateShow}
            >
              Create New Game
            </button>
          )}
        </div>
      </div>
      {loader ? (
        <ScreenLoader />
      ) : (
        <div className="card shadow mb-4">
          <div className="table-responsive">
            <table className="table table-bordered dataTable" width="100%">
              <thead>
                <tr className="bg-gray-300">
                  <th>Id</th>
                  <th>EventId</th>
                  <th>Event Name</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Start Number</th>
                  <th>End Number</th>
                  <th>Win Formula</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(eventMarket) && eventMarket.map((game, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "even" : "odd"}
                  >
                    <td>{game.id}</td>
                    <td>{game.GameName}</td>
                    <td>{game.EventName}</td>
                    <td>{game.StartTime}</td>
                    <td>{game.EndTime}</td>
                    <td>{game.StartNumber}</td>
                    <td>{game.EndNumber}</td>
                    <td>{game.WinFormula}</td>
                    <td>
                      <button className={`${game.Status ? "custom-green-btn" : "custom-grey-btn"}`} onClick={() => handleMarketActive(game.EventId)}>{game.Status ? 'Active' : 'De-Active'}</button>
                      <button className="custom-grey-btn" onClick={() => editEventMarket(game)}>Edit</button>
                      <button className="custom-grey-btn" >Delete</button>

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default SMGamesTable;
